<script setup lang="ts">
    interface LookbookHighlightProps {
        data: LookbookHighlightData;
    }
    const props = defineProps<LookbookHighlightProps>();

    const { textColorClass, textColorStyle, buttonColorClass, buttonColorStyle, buttonLabelColorClass, buttonLabelColorStyle } = useStyleCustom(
        props.data.style,
    );
</script>
<template>
    <section
        :id="data.codename"
        class="mol-lookbook-highlight relative my-8 lg:py-10">
        <atm-grid :id="data.anchor">
            <div
                class="relative col-span-2 md:col-span-12 lg:col-span-6"
                :class="{ 'lg:order-last': data.style?.settings?.[0] === 'flip' }">
                <div class="lb-highlight-visual">
                    <atm-image
                        :data="data.hero"
                        preset="1to1"
                        sizes="100vw md:1024px lg:1264px"
                        cover />
                </div>
            </div>
            <div class="lb-highlight-content col-span-2 mt-6 flex md:col-span-12 lg:col-span-5">
                <div class="flex w-full flex-col max-lg:mx-8 max-md:mx-6 lg:justify-center">
                    <div
                        :class="[textColorClass, 'flex flex-col gap-6']"
                        :style="textColorStyle">
                        <lazy-atm-heading
                            v-if="data.title"
                            level="h3">
                            <renderer-html :content="woomTextFormat(data.title)" />
                        </lazy-atm-heading>
                        <div>
                            <div
                                v-if="data.copy"
                                class="flex flex-col gap-4">
                                <renderer-html :content="woomTextFormat(data.copy)" />
                            </div>
                        </div>
                        <div>
                            <lazy-atm-cta-cms
                                v-if="data.link?.label"
                                :link="data.link"
                                styling="outline-auto"
                                :class="['mt-2', buttonColorClass, buttonLabelColorClass]"
                                :style="[buttonColorStyle, buttonLabelColorStyle]">
                                <renderer-html :content="woomTextFormat(data.link.label)" />
                            </lazy-atm-cta-cms>
                        </div>
                    </div>
                </div>
            </div>
        </atm-grid>
    </section>
</template>
<style scoped>
    @reference "#main.css";
    .mol-lookbook-highlight + .mol-lookbook-highlight {
        @apply lg:mt-40;
    }
    @variant lg {
        .lb-highlight-visual {
            transform: translateY(var(--translate));
        }
        .lb-highlight-content {
            transform: translateY(var(--translate));
        }
    }
</style>
